export default __webpack_public_path__ + "static/media/phil-equity.a957a738.png";